import { useState } from 'react'
import image from './images/1.jpg'
import cool from './images/cool.svg'

const DETAILS = [
  {
    title: 'もし枯れてたら？安心の品質補償',
    body: 'もし商品が「枯れている」「折れている」などの不備がございましたら、返金もしくは代品にて補償が可能です。お気軽にサポートまでお問い合わせください。',
  },
  {
    title: '不在時はお届けをスキップできる',
    body: '旅行や出張などで荷物の受け取りができない場合は、スキップ機能をご利用ください。お届けを1回分お休みすることができます。次回発送の3日前の正午までに、マイページからお手続きをお願いします。',
  },
  {
    title: '違約金なし！いつでも解約OK',
    body: '定期便はいつでも解約が可能です。違約金や最低契約期間はありません。次回発送の3日前の正午までに、マイページからお手続きください。',
  },
]

const DetailAccordion: React.FC<(typeof DETAILS)[number]> = ({ title, body }) => {
  const [open, setOpen] = useState(false)

  return (
    <button
      type="button"
      onClick={() => setOpen(!open)}
      className="bg-white rounded-2xl p-4 w-full text-left drop-shadow-[0_8px_8px_rgba(197,197,197,0.05)] cursor-pointer"
    >
      <span className="flex items-center justify-between gap-2">
        <span className="text-[15px] font-bold text-black">{title}</span>
        <svg
          className={`w-4 h-4 shrink-0 text-black transition-transform ${open ? 'rotate-180' : ''}`}
          viewBox="0 0 16 16"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
        >
          <path d="M3 6l5 5 5-5" />
        </svg>
      </span>
      {open && <span className="block mt-3 text-[13px] leading-[1.7] text-main">{body}</span>}
    </button>
  )
}

export const PricingSection: React.FC = () => {
  return (
    <section id="pricing" className="bg-bg pt-6 pb-14 px-6">
      <div className="max-w-md mx-auto flex flex-col gap-6">
        <div className="flex flex-col gap-2 items-center text-center">
          <p className="text-[16px] text-accent font-dm-serif font-medium">Plan / Price</p>
          <h2 className="text-[24px] font-bold text-black">プラン・料金</h2>
        </div>

        <div className="bg-white rounded-3xl p-4 flex flex-col gap-4 shadow-[0_8px_16px_rgba(197,197,197,0.05)]">
          <img src={image} alt="" className="w-full aspect-square object-cover rounded-2xl" />
          <div className="px-5 pb-5 flex flex-col gap-5">
            <div className="flex flex-col gap-2">
              <div className="flex items-center justify-center gap-4 font-sans">
                <span className="bg-[#ecebe9] rounded-full px-3 py-0.5 text-[15px] font-bold text-black">1配送</span>
                <span className="flex flex-col items-start">
                  <span className="text-accent font-bold leading-normal">
                    <span className="text-[28px]">3,740</span>
                    <span className="text-[18px]">円</span>
                    <span className="text-[12px]">（送料無料）</span>
                  </span>
                </span>
              </div>
              <p className="text-[12px] font-bold text-black text-center">配送ごとにお支払い・いつでも解約OK</p>
            </div>

            <hr className="border-none w-full h-px" style={{
              backgroundImage: "linear-gradient(to right, #dedcd7 37.5%, transparent 0%)",
              backgroundRepeat: "repeat-x",
              backgroundSize: "8px 1px",
            }} />

            <div className="flex flex-col gap-2 text-[15px] text-black">
              <div className="flex gap-2 items-start leading-normal">
                <span className="font-bold w-22.5 shrink-0">お届け頻度</span>
                <span>月に1〜4回から選択可</span>
              </div>
              <div className="flex gap-2 items-start leading-normal">
                <span className="font-bold w-22.5 shrink-0">花束のサイズ</span>
                <span>
                  長さ30cm〜42cm
                  <br />
                  本数は品種により変わります
                </span>
              </div>
              <div className="flex items-center leading-normal">
                <img src={cool} alt="" className="inline-block mr-1" />
                <p className="text-[12px] text-[#858585] tracking-[0.02em]">夏期はクール便でお届け（+330円）</p>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-4">
          {DETAILS.map((detail) => (
            <DetailAccordion key={detail.title} {...detail} />
          ))}
        </div>
      </div>
    </section>
  )
}
